<template>
	<div>
	<c-dialog ref="dialog" width="650" enable-flex mask-close height="700" @close="clearTimers">
		<div class="m-pay-body">
			<!-- 加载状态 -->
			<div v-if="loading" class="m-pay-loading flex-center">
				<i class="tf-loading m-loading-icon"></i>
				<span>加载中...</span>
			</div>

			<template v-else>
				<!-- 付款金额 -->
				<div class="m-pay-amount flex-center">
					<span class="m-pay-amount-label">收款金额：</span>
					<span class="m-pay-amount-value">{{formatPrice(totalAmount)}}</span>
                </div>

				<div v-if="allinpay_member_error == 1">
                    <c-tips>当前登录用户【{{userInfo.user_realname}}】尚未完成通联账户开通，无法使用线上支付</c-tips>
                </div>

				<!-- 选择收款方式 -->
				<div class="m-pay-item">
					<label class="m-label"><span class="m-required">*</span> 选择收款方式</label>
					<c-radio-group v-model="payMethod">
						<c-radio v-for="item in payMethodOptions" :key="item.value" :value="item.value" @click.native="switchPayMethod(item.value)">{{item.name}}</c-radio>
					</c-radio-group>
				</div>

				<!-- 线下支付 -->
				<template v-if="payMethod == 'offline'">
					<div class="m-pay-item">
						<label class="m-label"><span class="m-required">*</span> 类型</label>
						<c-radio-group v-model="selectedOfflineChannel">
							<c-radio v-for="item in offlinePayChannels" :key="item.code" :value="item.code" @click.native="onOfflineChannelChange(item.code)">{{item.name}}</c-radio>
						</c-radio-group>
					</div>
                    <!-- 显示收款码（仅收款码类型时显示） -->
                    <div v-if="selectedOfflineChannel == 'offline_qr_code'" class="m-pay-show-qr">
                        <c-link @click="$refs.offlinePayCode.open();">显示收款码↘</c-link>
                    </div>
					<!-- 银行转账信息 -->
					<template v-if="selectedOfflineChannel == 'offline_bank_card'">
						<div class="m-pay-bank">
							<p>开户银行：{{offlinePayConfig.bank_name || '-'}}</p>
							<p>账户名称：{{offlinePayConfig.bank_account_name || '-'}}</p>
							<p>银行账号：{{offlinePayConfig.bank_account_no || '-'}}</p>
						</div>
					</template>

					<!-- 上传付款凭证（线下公共） -->
					<div class="m-pay-item">
						<label class="m-label">上传收款凭证</label>
						<div class="m-upload-box" @click="triggerUpload">
							<template v-if="payVoucherUrl">
								<img :src="payVoucherUrl" class="m-upload-preview">
							</template>
							<i v-else class="tf-plus m-upload-icon"></i>
							<input ref="fileInput" type="file" accept="image/*" style="display:none" @change="fileChangeHandle">
						</div>
					</div>

					<!-- 备注（线下公共） -->
					<div class="m-pay-item">
						<label class="m-label">备注</label>
						<c-input v-model="payRemark" placeholder="" maxlength="200"></c-input>
					</div>


				</template>

				<!-- 线上支付 -->
				<template v-if="payMethod == 'online'">
					<div class="m-pay-item">
						<label class="m-label"><span class="m-required">*</span> 类型</label>
						<c-radio-group v-model="selectedOnlineChannel" @change="selectOnlineChannel">
							<c-radio v-for="item in onlinePayChannels" :key="item.code" :value="item.code" @click.native="selectOnlineChannel(item.code)">{{item.name}}</c-radio>
						</c-radio-group>
					</div>

					<!-- 二维码展示 -->
					<div class="m-pay-qrcode-large flex-center">
						<div class="m-pay-qrcode-border" :style="{'background': selectedOnlineChannel == 'wxpay_scan' ? '#00C277' : '#3D5EFF'}">
							<div class="m-pay-qrcode-head flex-center">
								<img v-if="selectedOnlineChannel" :src="require(`@/assets/image/pay_${selectedOnlineChannel}.png`)" alt="">
							</div>
							<div class="m-pay-qrcode">
								<c-qrcode v-if="qrCodeUrl" :value="qrCodeUrl" size="200"></c-qrcode>
							</div>
						</div>
						<p class="m-pay-scan-tip">请买方客户扫码付款</p>
					</div>
				</template>
			</template>
		</div>

		<!-- 订单列表 -->
		<div class="m-pay-orders flex-grow flex-column">
			<label class="m-label">关联订单</label>
			<div class="m-order-list flex-grow">
				<div v-for="order in orderList" :key="order.order_id" class="m-order-item">
					<span class="m-order-no">{{order.order_no}}</span>
					<div class="m-order-info">
						<m-product-info :name="order.product_name" :level="order.level_type" :code="order.produce_code" :imei="order.imei"></m-product-info>
					</div>
					<span class="m-order-amount">{{formatPrice(order.total_amount)}}</span>
				</div>
			</div>
		</div>

		<template #button>
			<!-- 线下支付显示确认按钮 -->
			<c-button v-if="payMethod != 'online'" size="dialog" color="main" :loading="submitting" @click="submitHandle">确认付款</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>

	<c-dialog ref="offlinePayCode" title="收款码" width="400" :button="false">
		<div v-if="offlinePayConfig.qr_code_url" class="m-pay-qrcode-display">
			<img :src="offlinePayConfig.qr_code_url" class="m-pay-qrcode-img">
			<p class="m-pay-tip">客户扫码付款后可上传凭证</p>
		</div>
		<p v-else class="m-pay-tip">暂未配置收款码，请联系管理员配置</p>
	</c-dialog>
	</div>
</template>

<script>
	import {mapState} from "vuex";

    export default {
		name: 'salePayDialog',

		data() {
			return {
				loading: false,
				submitting: false,
				orderIds: [],
				payTradeNumber: '',
				totalAmount: 0,
				hasOnlinePay: false,
				hasOfflinePay: false,
                hasCreditPay: false,//是否支持授信支付
				offlinePayChannels: [],
				onlinePayChannels: [],
				offlinePayConfig: {},
				orderList: [],
				payMethod: 'offline',
				selectedOfflineChannel: '',
				selectedOnlineChannel: '',//默认使用微信
				payVoucherUrl: '',
				payRemark: '',
				showQrCode: false,
				qrCodeUrl: '',
				countdown: 600,
				countdownTimer: null,
				pollTimer: null,
				payMethodOptions: [],
                allinpay_member_error: 0,           //不支持通联收款
                onlinePayStarted: false              //本次是否已发起通联线上支付（发起后禁止改用线下收款）
			}
		},

        watch: {
            //收款全程只使用打开弹窗时生成的支付单号：切换收款方式不再重新生成，避免旧支付单遗留「已付款待回调」引发重复收款
            payMethod(val) {
                if (val == 'online' && this.selectedOnlineChannel == ''){
                    this.selectOnlineChannel('wxpay_scan');
                }
            }
        },

		computed: {
            ...mapState(['saasInfo', 'userInfo']),

            countdownText() {
				var minutes = Math.floor(this.countdown / 60);
				var seconds = this.countdown % 60;
				return minutes + '分' + (seconds < 10 ? '0' : '') + seconds + '秒';
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				this.orderIds = data.orderIds || [];
				this.resetData();
				this.$refs.dialog.open({title: '收款'});
				this.loadPayConfig();
			},

			/*********重置数据**********/
			resetData() {
				this.loading = true;
				this.submitting = false;
				this.payTradeNumber = '';
				this.totalAmount = 0;
				this.hasOnlinePay = false;
				this.hasOfflinePay = false;
				this.hasCreditPay = false;
				this.offlinePayChannels = [];
				this.onlinePayChannels = [];
				this.offlinePayConfig = {};
				this.orderList = [];
				this.payMethod = 'offline';
				this.selectedOfflineChannel = '';
				this.selectedOnlineChannel = '';
				this.payVoucherUrl = '';
				this.payRemark = '';
				this.showQrCode = false;
				this.qrCodeUrl = '';
				this.onlinePayStarted = false;
				this.countdown = 600;
				this.clearTimers();
			},

			/*********加载支付配置**********/
			loadPayConfig(callback) {
				this.request({
					url: '/offline/sale/order/unionPay',
					data: {
						order_ids: this.orderIds
					},
					loading: true,
					success: data => {
						this.payTradeNumber = data.pay_trade_number;
						this.totalAmount = parseFloat(data.total_amount) || 0;
						this.hasOnlinePay = data.has_online_pay || false;
						this.hasOfflinePay = data.has_offline_pay || false;
						this.hasCreditPay = data.has_credit_pay || false;
						this.offlinePayChannels = data.offline_pay_channels || [];
						this.onlinePayChannels = data.online_pay_channels || [];
						this.offlinePayConfig = data.offline_pay_config || {};
						this.allinpay_member_error = data.allinpay_member_error || 0;
						this.orderList = data.orders || [];
						this.buildPayMethodOptions();
						this.loading = false;
						// 默认选中第一个线下渠道
                        if (this.selectedOfflineChannel == ''){
                            if (this.payMethod == 'offline' && this.offlinePayChannels.length) {
                                this.selectedOfflineChannel = this.offlinePayChannels[0].code;
                            }
                            if (this.payMethod == 'online' && !this.selectedOnlineChannel) {
                                this.selectOnlineChannel(this.onlinePayChannels[0].code);
                            }
                        }
						callback && callback();
					},
					error: () => {
						this.loading = false;
					}
				});
			},

			/*********构建收款方式选项**********/
			buildPayMethodOptions() {
				var options = [];
				if (this.hasOfflinePay) {
					options.push({name: '线下支付', value: 'offline'});
				}
				if (this.hasOnlinePay) {
					options.push({name: '线上支付', value: 'online'});
				}
				this.payMethodOptions = options;
				// 默认选中第一个
				if (options.length > 0 && !options.find(o => o.value == this.payMethod)) {
					this.payMethod = options[0].value;
				}
			},

			/*********切换线下渠道**********/
			onOfflineChannelChange(code) {
				if (this.selectedOfflineChannel == code) return;
				this.selectedOfflineChannel = code;
				this.showQrCode = false;
			},

			/*********切换收款方式**********/
			switchPayMethod(value) {
				//已发起通联线上支付并等待回调：禁止改用线下收款，否则同一笔订单会被重复收款（需先于 v-model 已同步的 return 判断）
				if (this.onlinePayStarted && value != 'online') {
					this.$message({message: '已发起线上支付并在等待支付结果，请勿改用其他方式收款；如客户确未付款，请关闭本窗口后重新发起收款', type: 'warn'});
					this.$nextTick(() => { this.payMethod = 'online'; });
					return;
				}
				if (this.payMethod == value) return;
				this.payMethod = value;
				this.qrCodeUrl = '';
				this.clearTimers();
			},

			/*********选择线上支付渠道**********/
			selectOnlineChannel(code) {
				// 守卫：重复点击已选渠道不重复生成二维码（与 c-radio 已选不重触发语义一致）
				if (this.selectedOnlineChannel == code) return;
				//同一支付单内切换支付渠道，不重新生成支付单号（换新单号会让旧单永远停在「已付款待回调」）
				this.qrCodeUrl = '';
				this.selectedOnlineChannel = code;
				this.generateQrCode(code);
			},

			/*********生成二维码**********/
			generateQrCode(payMethod) {
				this.request({
					url: '/allinpay/collect/apply',
					data: {
						pay_trade_number: this.payTradeNumber,
						pay_method: payMethod
					},
					loading: true,
					success: data => {
						if (data.payInfo) {
							this.qrCodeUrl = data.payInfo;
							this.onlinePayStarted = true;
							this.startCountdown();
							this.checkPayStatus();
						} else {
							this.$message({message: '生成二维码失败', type: 'error'});
						}
					}
				});
			},

			/*********开始倒计时**********/
			startCountdown() {
				clearInterval(this.countdownTimer);
				this.countdown = 600;
				this.countdownTimer = setInterval(() => {
					this.countdown--;
					if (this.countdown <= 0) {
						this.clearTimers();
						this.$message({message: '二维码已过期，请重新生成', type: 'warn'});
					}
				}, 1000);
			},

			/*********查询支付状态**********/
			checkPayStatus() {
                if (this.payMethod == 'online'){
                    this.clearTimers();
                    this.pollRequest = this.request({
                        url: '/allinpay/collect/query',
                        data: {
                            pay_trade_number: this.payTradeNumber
                        },
                        success: data => {
                            if (data.status == 2) {
                                this.clearTimers();
                                this.$message({message: '支付成功', type: 'success'});
                                this.$refs.dialog.close();
                                this.$emit('resolve');
                            } else {
                                this.pollTimer = setTimeout(this.checkPayStatus, 1000);
                            }
                        }
                    });
                }
			},

			/*********清除定时器**********/
			clearTimers() {
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}
				if (this.pollRequest) {
					this.pollRequest.abort();
					this.pollRequest = null;
				}
				if (this.pollTimer) {
					clearTimeout(this.pollTimer);
					this.pollTimer = null;
				}
			},

			/*********触发文件选择**********/
			triggerUpload() {
				this.$refs.fileInput.click();
			},

			/*********文件选择处理**********/
			fileChangeHandle(e) {
				var file = e.target.files[0];
				if (!file) return;
				this.$upload({
					files: [file],
					type: 'image',
					loading: true,
					success: data => {
						if (Array.isArray(data)) {
							this.payVoucherUrl = data[0].path;
						} else {
							this.payVoucherUrl = data.path;
						}
					}
				});
				e.target.value = '';
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********确认付款**********/
			submitHandle() {
				if (this.totalAmount <= 0) {
					this.$message({message: '该订单无待收金额', type: 'warn'});
					return;
				}
				//已发起通联线上支付：必须等支付结果，不能再用现金/收款码等方式确认收款
				if (this.onlinePayStarted && this.payMethod != 'online') {
					this.$message({message: '已发起线上支付并在等待支付结果，请勿改用其他方式收款；如客户确未付款，请关闭本窗口后重新发起收款', type: 'warn'});
					return;
				}

				var data = {
					pay_trade_number: this.payTradeNumber,
					pay_method: this.selectedOfflineChannel
				};
				
				// 上传凭证（线下公共，非必填）
				if (this.payVoucherUrl) {
					data.pay_voucher_url = this.payVoucherUrl;
				}
				
				// 备注（线下公共，非必填）
				if (this.payRemark) {
					data.remark = this.payRemark.trim();
				}

				this.submitting = true;
				this.request({
					url: '/offline/sale/order/pay',
					data: data,
					loading: true,
					success: (data, msg) => {
						this.submitting = false;
						this.$message({message: msg || '收款成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					},
					error: () => {
						this.submitting = false;
					}
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.clearTimers();
				this.$refs.dialog.close();
			}
		},

		beforeDestroy() {
			this.clearTimers();
		}
	}
</script>

<style lang="stylus" scoped>
	.m-pay-body {
		padding: 0 24px;
		min-height: 300px;
	}

	.m-pay-loading {
		height: 200px;
		color: #999;

		.m-loading-icon {
			font-size: 24px;
			margin-right: 8px;
			animation: rotate 1s linear infinite;
		}
	}

	@keyframes rotate {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}

	.m-pay-amount {
		padding: 20px 0;

		.m-pay-amount-label {
			font-size: 16px;
			color: #666;
		}

		.m-pay-amount-value {
			font-size: 30px;
			font-weight: bold;
			color: #F70000;
		}
	}

	.m-pay-item {
		margin-bottom: 16px;

		.m-label {
			display: block;
			margin-bottom: 12px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}
	}

	.m-pay-tabs {
		display: flex;
		gap: 12px;

		.m-pay-tab {
			position: relative;
			padding: 6px 24px;
			border: 1px solid #d9d9d9;
			border-radius: 4px;
			font-size: 14px;
			color: #333;
			background: #fff;
			cursor: pointer;
			transition: all .2s;
			user-select: none;

			&:hover {
				border-color: #1890ff;
				color: #1890ff;
			}

			&.z-active {
				border-color: #1890ff;
				color: #1890ff;

				&::after {
					content: '';
					position: absolute;
					right: 0;
					bottom: 0;
					width: 0;
					height: 0;
					border-style: solid;
					border-width: 0 0 10px 10px;
					border-color: transparent transparent #1890ff transparent;
				}
			}
		}
	}

	.m-upload-box {
		position: relative;
		width: 80px;
		height: 80px;
		border: 1px dashed #d9d9d9;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: border-color .2s;
		background: #fafafa;

		&:hover {
			border-color: #1890ff;
		}

		.m-upload-icon {
			font-size: 24px;
			color: #999;
		}

		.m-upload-preview {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 4px;
		}
	}

	.m-pay-qrcode-display {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
		padding: 16px 0;

		.m-pay-qrcode-img {
			width: 260px;
			height: 260px;
			object-fit: contain;
			border: 1px solid #e8e8e8;
			border-radius: 4px;
		}
	}

	.m-pay-qrcode-large {
		flex-direction: column;
		gap: 16px;
		padding-bottom: 20px;

		.m-pay-qrcode-border {
			border-radius: 8px;
			padding: 0 5px 5px;
		}
		.m-pay-qrcode-head {
			height: 40px;
			padding: 10px 0;
		}
		.m-pay-qrcode {
			width: 200px;
			height: 200px;
			padding: 12px;
			border-radius: 8px;
			background: #fff;
		}

		.m-pay-scan-tip {
			font-size: 18px;
			color: #FF5555;
		}

		.m-pay-countdown {
			font-size: 13px;
			color: #999;
		}
	}

	.m-pay-tip {
		font-size: 13px;
		color: #999;
		text-align: center;
	}

	.m-pay-bank {
		padding: 10px 16px;
		margin-bottom: 16px;
		background: #f9f9f9;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		line-height: 24px;
		font-size: 13px;
		color: #333;
	}

	.m-pay-show-qr {
		margin-top: 8px;
		margin-bottom: 16px;

		.m-pay-show-qr-link {
			display: inline-flex;
			align-items: center;
			gap: 4px;
			font-size: 13px;
			color: #1890ff;
			cursor: pointer;
			text-decoration: none;

			&:hover {
				color: #40a9ff;
			}

			i {
				font-size: 12px;
			}
		}
	}

	.m-pay-orders {
		border-top: 1px solid #eee;
		padding: 16px 0;
		margin: 0 24px;

		.m-label {
			display: block;
			margin-bottom: 12px;
			font-size: 14px;
			color: #333;
		}

		.m-order-list {
			overflow-y: auto;
		}

		.m-order-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 12px;
			margin-bottom: 8px;
			padding: 8px 20px;
			background: #fafafa;
			border-radius: 4px;
			font-size: 13px;

			&:nth-last-child(1) {
				margin-bottom: 0;
			}

			.m-order-no {
				flex-shrink: 0;
				width: 180px;
				color: #666;
			}

			.m-order-info {
				flex: 1;
				min-width: 0;
			}

			.m-order-amount {
				flex-shrink: 0;
				color: #333;
				font-weight: bold;
			}
		}
	}
</style>
